import { render, staticRenderFns } from "./EmployeeInfo.vue?vue&type=template&id=194a470f"
import script from "./EmployeeInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports